// Module
var code = `<section class="layout"> <main> <component-notification></component-notification> <div id="content"></div> </main> </section> `;
// Exports
export default code;